(() => {
  const SlideshowItem = customElements.get('slide-show-item');

  if (SlideshowItem && !SlideshowItem.prototype.cvbVerticalTransitionReady) {
    const originalLeave = SlideshowItem.prototype.transitionToLeave;
    const originalEnter = SlideshowItem.prototype.transitionToEnter;

    SlideshowItem.prototype.cvbVerticalTransitionReady = true;

    SlideshowItem.prototype.transitionToLeave = async function(transitionType, shouldAnimate = true) {
      if (transitionType !== 'vertical') {
        return originalLeave.call(this, transitionType, shouldAnimate);
      }

      if (!shouldAnimate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.hidden = true;
        return;
      }

      const slideshow = this.closest('slide-show');
      const duration = Number(slideshow?.dataset.transitionDuration) || 800;
      const surface = this.querySelector('.slideshow__slide-inner') || this;
      surface.style.willChange = 'transform, opacity, clip-path';
      this.style.zIndex = '2';

      const animation = surface.animate([
        { transform: 'translate3d(0, 0, 0)', clipPath: 'inset(0 0 0 0)', opacity: 1 },
        { transform: 'translate3d(0, 12%, 0)', clipPath: 'inset(0 0 12% 0)', opacity: 1, offset: 0.58 },
        { transform: 'translate3d(0, 100%, 0)', clipPath: 'inset(0 0 100% 0)', opacity: 0.98 }
      ], {
        duration: Math.round(duration * 0.78),
        easing: 'cubic-bezier(0.55, 0.02, 0.82, 0.45)',
        fill: 'both'
      });

      await animation.finished.catch(() => {});
      this.hidden = true;
      animation.cancel();
      surface.style.willChange = '';
      this.style.zIndex = '';
    };

    SlideshowItem.prototype.transitionToEnter = async function(transitionType, shouldAnimate = true) {
      if (transitionType !== 'vertical') {
        return originalEnter.call(this, transitionType, shouldAnimate);
      }

      this.hidden = false;
      await this._untilReady();

      if (!shouldAnimate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const slideshow = this.closest('slide-show');
      const duration = Number(slideshow?.dataset.transitionDuration) || 800;
      const surface = this.querySelector('.slideshow__slide-inner') || this;
      surface.style.willChange = 'transform, opacity, clip-path';
      this.style.zIndex = '1';

      const animation = surface.animate([
        { transform: 'translate3d(0, 100%, 0)', clipPath: 'inset(100% 0 0 0)', opacity: 0.98 },
        { transform: 'translate3d(0, -3%, 0)', clipPath: 'inset(0 0 0 0)', opacity: 1, offset: 0.82 },
        { transform: 'translate3d(0, 0, 0)', clipPath: 'inset(0 0 0 0)', opacity: 1 }
      ], {
        duration,
        easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
        fill: 'both'
      });

      await animation.finished.catch(() => {});
      animation.cancel();
      surface.style.willChange = '';
      this.style.zIndex = '';
    };
  }
})();

if (!customElements.get('cvb-slideshow-nav')) {
  customElements.define('cvb-slideshow-nav', class extends HTMLElement {
    connectedCallback() {
      this.slideshow = this.closest('.slideshow');
      if (!this.slideshow || this.dataset.ready === 'true') return;

      this.dataset.ready = 'true';
      this.dots = [...this.slideshow.querySelectorAll('.slideshow__progress-bar')];
      this.slides = [...this.slideshow.querySelectorAll('.slideshow__slide')];
      this.previousButton = this.querySelector('[data-cvb-slide-prev]');
      this.nextButton = this.querySelector('[data-cvb-slide-next]');
      this.progress = this.querySelector('.cvb-slideshow-nav__progress');
      this.section = this.closest('.shopify-section');
      this.autoplayDuration = parseFloat(getComputedStyle(this.section).getPropertyValue('--section-autoplay-duration')) || 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.onPrevious = () => this.move(-1);
      this.onNext = () => this.move(1);
      this.onProgressEnd = (event) => {
        if (event.animationName === 'cvbSlideshowProgress' && this.autoplayDuration > 0 && !this.reducedMotion) {
          this.move(1);
        }
      };

      this.previousButton.addEventListener('click', this.onPrevious);
      this.nextButton.addEventListener('click', this.onNext);
      this.progress.addEventListener('animationend', this.onProgressEnd);

      this.observer = new MutationObserver(() => this.update());
      this.dots.forEach((dot) => this.observer.observe(dot, {
        attributes: true,
        attributeFilter: ['aria-current']
      }));

      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.previousButton?.removeEventListener('click', this.onPrevious);
      this.nextButton?.removeEventListener('click', this.onNext);
      this.progress?.removeEventListener('animationend', this.onProgressEnd);
    }

    currentIndex() {
      const index = this.dots.findIndex((dot) => dot.getAttribute('aria-current') === 'true');
      return index < 0 ? 0 : index;
    }

    move(direction) {
      if (!this.dots.length) return;
      const targetIndex = (this.currentIndex() + direction + this.dots.length) % this.dots.length;
      this.dots[targetIndex]?.click();
    }

    update() {
      if (!this.slides.length) return;

      const nextIndex = (this.currentIndex() + 1) % this.slides.length;
      const nextImage = this.slides[nextIndex]?.querySelector('.slideshow__image');
      const source = nextImage?.currentSrc || nextImage?.src;

      if (source) {
        this.nextButton.style.setProperty('--cvb-slide-next-image', `url("${source}")`);
      }

      if (this.autoplayDuration > 0 && !this.reducedMotion) {
        this.progress.style.animation = 'none';
        void this.progress.offsetWidth;
        this.progress.style.animation = '';
      }
    }
  });
}
